import React, { useState, useEffect, useRef } from "react";
import { Divider } from '@mui/material';
import styled from "styled-components";
import {
  Ptag,
  OverlayLoader,
  LargeButton,
  SimpleDateField,
  Icons,
  BaseDropdown,
} from "components/core";
import http from "services/httpService";
import { useNavigate } from "react-router-dom";
import { SideNav, SideNavContent } from "components";
import routes from "components/routes";
import { formatDate, formatToRupees, rupeesToNumber } from "utlis/utils";
import HeaderDasNew from "components/core/headerDasNew";
import UploadFile from "components/UploadFile";
import { products } from "utlis/utils";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import { theme } from "theme";

const UploadPolicyNos = () => {
  const [loading, setLoading] = useState(false);
  const [uploadErrorData, setUploadErrorData] = useState([]);
  const [documentId, setDocumentId] = useState();
  const [invoiceId, setInvoiceId] = useState();
  const [creditMemoId, setCreditMemo] = useState();
  const [creditAmount, setCreditAmount] = useState("");
  const [creditDate, setCreditDate] = useState("");
  const [amount, setAmount] = useState("");
  const [paymentdate, setPaymentDate] = useState("");
  const [excelNameError, setExcelNameError] = useState(false);
  const [amountError, setAmountError] = useState("*required");
  const [dateError, setDateError] = useState("*required");
  const [isShow, setIsShow] = useState(false);
  const [showUploadInvoice, setShowUploadInvoice] = useState(false);
  const [showCreditMemo, setShowCredieMemo] = useState(false);
  const company_name = localStorage.getItem("company_name");
  const [selectedValue, setSelectedValue] = useState("");
  const [showError, setShowError] = useState(false)
  const [showErrorRefund, setShowErrorRefund] = useState(false)
  const [employeewiseSheet, setEmployeewiseSheet] = useState()
  const [credidMemoEmpSheet, setCredidMemoEmpSheet] = useState()
  const ref = useRef();
  const ref2 = useRef();
  const options = products();
  const showSidebar = () => {
    return !!localStorage.getItem("id");
  };
  const renderError = (error, style) => {
    return <Error style={style}>{error}</Error>;
  };
  const navigate = useNavigate();
  const navigateToNextPage = () => {
    navigate(`/${routes.CARE_DASHBOARD}`);
  };
  const onUpload = async (id) => {
    setDocumentId(id);
    setUploadErrorData([]);
    try {
      const data2 = await http.post("/business/validate_endorsement_upload/", {
        document_id: id,
        business_type: selectedValue,
      });
      data2 &&
        data2.data &&
        setShowUploadInvoice(data2.data.invoice_upload_required);
      data2 &&
        data2.data &&
        setShowCredieMemo(data2.data.credit_memo_upload_required);
    } catch (ex) {
      if (ex.response && Array.isArray(ex.response.data)) {
        setUploadErrorData(
          (ex.response &&
            Array.isArray(ex.response.data) &&
            ex.response.data) ||
            []
        );
      }
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async () => {
    setShowError(false)
    setShowErrorRefund(false)
    const currentDate = new Date()
    if( !showUploadInvoice && !documentId){
        setIsShow(true)
        return
    }
    const payment_date = new Date(formatDate(paymentdate))
    const credit_date = new Date(formatDate(creditDate))
    const error_for_invoice = ((!amount || !paymentdate) || ((payment_date > currentDate) || (paymentdate.length < 10)))
    const error_for_refund = ((!creditAmount || !creditDate) || ((credit_date > currentDate) || (creditDate.length < 10)))
    if ((showUploadInvoice && error_for_invoice) || (showCreditMemo && error_for_refund)) {
      if (showUploadInvoice && error_for_invoice) {
        if ((payment_date > currentDate) || (paymentdate.length < 10)) {
          setDateError('*Enter a valid Date')
          setShowError(true)
        }
      }
      if (showCreditMemo && error_for_refund) {
        if ((credit_date > currentDate) || (creditDate.length < 10)) {
          setDateError('*Enter a valid Date')
          setShowErrorRefund(true)
        }
      }
      setIsShow(true)
      return
    }

    setLoading(true)

    try {
      await http.post("/business/upload_employee_issuance_data/", {
        // userplan_id: userplan_id,
        business_type: selectedValue,
        document_id: documentId,
        invoice_id: invoiceId || null,
        refund_id: creditMemoId || null,
        refund_date: formatDate(creditDate),
        refund_amount: rupeesToNumber(creditAmount),
        payment_date: formatDate(paymentdate),
        amount: rupeesToNumber(amount),
        invoice_employee_wise_breakup_sheet_id: employeewiseSheet,
        credit_memo_employee_wise_breakup_sheet_id: credidMemoEmpSheet,
        invoice_type: "PREMIUM",
      });

      navigateToNextPage();
    } catch (ex) {
      alert(ex);
      setLoading(false);
    }
  };
  useEffect(() => {
    // getSummeryData()
  }, []);

  const getOptions = (options) => {
    return options.map((option) => ({
      ...option,
      title: option.label,
    }));
  };

  const updateSelectedValue = (value) => {
    setSelectedValue(value)
  }

  const handleDateChange = (value) => {
    let newDate = value
    if(!paymentdate){
        setPaymentDate(newDate)
        return
    }
    let prevDateLen = paymentdate.length
    let newDateLen = value.length
    let newDob = newDate

    if (newDateLen < prevDateLen) {
        newDob = paymentdate.substr(0, prevDateLen - 1)
    } else if (newDateLen <= 10) {
        if (newDateLen === 2 || newDateLen === 5) {
            newDob = newDate + '/'
        }
    } else {
        newDob = newDate.slice(0, 10)
    }
    setPaymentDate(newDob)
  }
  const handleDateChangeRefund = (value) => {
    let newDate = value
    if(!creditDate){
        setCreditDate(newDate)
        return
    }
    let prevDateLen = creditDate.length
    let newDateLen = value.length
    let newDob = newDate

    if (newDateLen < prevDateLen) {
        newDob = creditDate.substr(0, prevDateLen - 1)
    } else if (newDateLen <= 10) {
        if (newDateLen === 2 || newDateLen === 5) {
            newDob = newDate + '/'
        }
    } else {
        newDob = newDate.slice(0, 10)
    }
    setCreditDate(newDob)
  }
  const handleAmountChange = (value, id) => {
    const modifiedAmouunt = formatToRupees(value)
    if(id == "debit"){
      setAmount(modifiedAmouunt)
    } else{
      setCreditAmount(modifiedAmouunt)
    }
}

  return (
    <>
      <SideNav>{showSidebar() && <SideNavContent />}</SideNav>
      <HeaderDasNew company_name={company_name} />

      <HomeWrapper>
        {loading && <OverlayLoader />}
        <Formik
          initialValues={{ policy_type: "" }}
          validationSchema={Yup.object().shape({
            policy_type: Yup.string().required("*Required"),
          })}
          onSubmit={handleSubmit}
        >
          {(formikProps) => (
            <>
              <Form>
                <Body>
                    <Ptag
                    fontSize="20px"
                    fontWeight="700"
                    letterHeight="1.33"
                    letterSpacing="0.35px"
                    style={{ paddingBottom: "30px" }}
                    >
                        Upload Endorsements
                    </Ptag>
                  <div style={{ marginBottom: "2.2rem", width: "50%" }}>
                    {updateSelectedValue(formikProps.values?.policy_type)}
                    <BaseDropdown
                    fontSize="14"
                      fontColor={theme.defaultFontColor}
                      label="Select Policy Type"
                      options={getOptions(options)}
                      formikProps={{ ...formikProps, name: "policy_type" }}
                    />
                  </div>
                  <UploadFile
                    text="Upload File"
                    format="excel"
                    type="policy_upload_excel"
                    onSelect={(id) => onUpload(id)}
                    showError={excelNameError}
                    sampleFile="PolicyNumber"
                    productType={selectedValue}
                  />
                </Body>
                {!!uploadErrorData.length && (
                  <ErrorTag>
                    <Ptag
                      color="#F27576"
                      style={{
                        paddingBottom: "12px",
                        height: "19px",
                        fontSize: "14px",
                        fontWeight: "700",
                      }}
                    >
                      Errors!
                    </Ptag>
                    <div>
                      <table
                        border="0.4px"
                        frame="void"
                        rules="all"
                        style={{ width: "100%" }}
                      >
                        <thead>
                          <tr>
                            <TableData>
                              <Ptag
                                style={{
                                  height: "10px",
                                  fontWeight: "600",
                                  textAlign: "center",
                                }}
                              >
                                ROW
                              </Ptag>
                            </TableData>
                            <TableData>
                              <Ptag
                                style={{
                                  height: "10px",
                                  fontWeight: "600",
                                  textAlign: "center",
                                }}
                              >
                                COLUMN
                              </Ptag>
                            </TableData>
                            <TableData>
                              <Ptag
                                style={{
                                  paddingLeft: "3px",
                                  width: "24px",
                                  height: "14px",
                                  fontWeight: "600",
                                }}
                              >
                                MESSAGE
                              </Ptag>
                            </TableData>
                          </tr>
                        </thead>
                        <tbody>
                          {uploadErrorData.map((error, index) => (
                            <tr>
                              <TableData>
                                <Ptag
                                  textAlign="center"
                                  style={{
                                    fontSize: "12px",
                                    fontWeight: "500",
                                  }}
                                >
                                  {error?.Row_number || ""}
                                </Ptag>
                              </TableData>
                              <TableData>
                                <Ptag
                                  textAlign="center"
                                  style={{
                                    fontSize: "12px",
                                    fontWeight: "500",
                                  }}
                                >
                                  {error?.column || ""} {"  "}
                                </Ptag>
                              </TableData>
                              <TableData>
                                <Ptag
                                  style={{
                                    fontSize: "12px",
                                    fontWeight: "600",
                                  }}
                                >
                                  {error?.error || ""}
                                </Ptag>
                              </TableData>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </ErrorTag>
                )}

                {showUploadInvoice && (
                  <Body>
                     <Divider/>  
                    <UploadFile
                      label="Upload Insurance Premium Invoice"
                      text="Upload Document"
                      format="pdf"
                      type="premiums_invoice"
                      onSelect={setInvoiceId}
                      // showError={excelNameError}
                    />

                    <AmountDiv>
                      <ColumnFlex>
                      <InputField>
                        <input
                          style={{
                            border: "0",
                            outline: "none",
                            height: "auto",
                            width: "100%",
                            fontSize: "medium",
                            paddingLeft: "18px",
                          }}
                          type="text"
                          value={amount}
                          placeholder="Enter Premium Amount"
                          onChange={(e) => handleAmountChange(e.target.value, "debit")}
                          required
                        />
                      </InputField>
                      {isShow &&
                        !amount &&
                        renderError(amountError, {
                          position: "inherit",
                          marginTop: "1.2rem",
                        })}
                      </ColumnFlex>
                      <ColumnFlex>
                      <SimpleDateField
                              value={paymentdate}
                              placeholder="Date of Payment (DD/MM/YYYY)"  
                              // error={"Enter a valid Date"}
                              onChange={(e) => handleDateChange(e.target.value, 'payment_date')}
                              required
                          >
                      </SimpleDateField>
                      {isShow &&
                        showError &&
                        renderError(dateError, {
                          position: "inherit",
                          marginTop: "1.2rem",
                        })}
                      </ColumnFlex>
                    </AmountDiv>
                    <UploadFile
                        label="Employee-wise Break-up"
                        text="Upload Document"
                        format="excel"
                        type="employee_wise_breakup"
                        onSelect={setEmployeewiseSheet}
                        bottom="-5rem"
                    />
                  </Body>
                )}
                {showCreditMemo && (
                  <Body>
                    <Divider sx={{ mt: 2 }}/>   
                    <UploadFile
                      label="Upload Credit Memo"
                      text="Upload Document"
                      format="pdf"
                      type="refund_credit_memo"
                      onSelect={setCreditMemo}
                      // showError={excelNameError}
                    />

                    <AmountDiv>
                      <ColumnFlex>
                      <InputField>
                        <input
                          style={{
                            border: "0",
                            outline: "none",
                            height: "auto",
                            width: "100%",
                            fontSize: "medium",
                            paddingLeft: "18px",
                          }}
                          type="text"
                          value={creditAmount}
                          placeholder="Enter Refund Amount"
                          onChange={(e) => handleAmountChange(e.target.value, "credit")}
                          required
                        />
                      </InputField>
                      {isShow &&
                        !creditAmount &&
                        renderError(amountError, {
                          position: "inherit",
                          marginTop: "1.2rem",
                        })}
                      </ColumnFlex>
                      <ColumnFlex>
                        <SimpleDateField
                            value={creditDate}
                            placeholder="Date of Refund (DD/MM/YYYY)"  
                            // error={"Enter a valid Date"}
                            onChange={(e) => handleDateChangeRefund(e.target.value, 'refund_date')}
                            required
                            >
                        </SimpleDateField>
                        {isShow &&
                        showErrorRefund &&
                        renderError(dateError, {
                          position: "inherit",
                          marginTop: "1.2rem",
                        })}
                      </ColumnFlex>
                    </AmountDiv>
                    <UploadFile
                        label="Employee-wise Break-up"
                        text="Upload Document"
                        format="excel"
                        type="employee_wise_breakup"
                        onSelect={setCredidMemoEmpSheet}
                        bottom="-5rem"
                    />
                  </Body>
                )}
                <ButtonWrapper>
                  <LargeButton
                    marginTop="24px"
                    id="business_about_next12"
                    textTransform="none"
                    label={"Update"}
                    type="submit"
                  />
                </ButtonWrapper>
              </Form>
            </>
          )}
        </Formik>
      </HomeWrapper>
    </>
  );
};
// }

const AmountDiv = styled.div`
  display: flex;
  flex-direction: row;
`;
const ButtonWrapper = styled.div`
  position: relative;
  bottom: 1rem;
  display: flex;
  align-items: flex-end;
`;

const Error = styled.p`
  color: red;
  font-size: 1.4rem;
  margin-top: 4rem;
  position: absolute;
  z-index: 9;
`;

const ColumnFlex = styled.div`
    display: flex;
    flex-direction: column;
`

const InputField = styled.div`
  display: flex;
  margin-top: 24px;
  margin-right: 20px;
  width: 341px;
  border: 1px solid #436ab2;
  border-radius: 6px;
  padding: 5px;
  justify-content: left;
  cursor: pointer;
  height: 50px;
`;

const Body = styled.div`
  display: flex;
  flex-direction: column;
  /* padding: 24px; */
  flex: 1;
`;

const HomeWrapper = styled.div`
  transition: margin-left 0.2s ease-in;
  padding: 30px 0px 20px 80px;
  padding-bottom: 20px;
  box-sizing: border-box;
  background: #fff;
  /* height:100vh; */
  margin-left: 200px;
  max-width: 800px;
  /* box-shadow: rgb(0 0 0 / 15%) 0px 1px 4px 0px; */
`;

const ErrorTag = styled.div`
  padding: 24px;
  background-color: #f8f8f8;
  border-radius: 10px;
  margin-bottom: 10px;
`;

const TableData = styled.td`
  padding: 10px;
`;

export default UploadPolicyNos;
